import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitInfoTextExtensionInterface } from '../../../extension/interface/benefit-info-text.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { WellpassBenefitInfoTextExtension } from './extension/wellpass-benefit-info-text.extension';
import { WellpassBenefitMetadataExtension } from './extension/wellpass-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('wellpass')
    .add(BenefitMetadataExtensionInterface, new WellpassBenefitMetadataExtension())
    .add(BenefitInfoTextExtensionInterface, new WellpassBenefitInfoTextExtension())
    .build(),
);
